import React from 'react';
import { InterpolateVariables } from 'providers/ContextVariables';
import hoistStatics from 'hoist-non-react-statics';

export const withInterpolate = pattern => Component => {
  const WithInterpolate = props => (
    <InterpolateVariables pattern={pattern}>
      {interpolate => <Component {...props} interpolate={interpolate} />}
    </InterpolateVariables>
  );

  WithInterpolate.displayName = `withInterpolate(${Component.displayName || Component.name})`;

  return hoistStatics(WithInterpolate, Component);
};
